/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

import {TableColumnAlignEnum, TableColumnEnum, TableColumnInterface} from '@shared/components/table';

/**
 * @description
 * Header array for sensors table
 */
export const SENSORS_MAIN_HEADERS: TableColumnInterface[] = [
  {
    field: 'name',
    type: TableColumnEnum.text,
    header: 'app.setting.sensor.fields.name.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'vendor',
    type: TableColumnEnum.text,
    header: 'app.setting.sensor.fields.vendor.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'reference',
    type: TableColumnEnum.text,
    header: 'app.setting.sensor.fields.ref.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'type_label',
    type: TableColumnEnum.text,
    header: 'app.setting.sensor.fields.type.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'enabled',
    type: TableColumnEnum.tag,
    header: 'app.setting.sensor.fields.status.header',
    align: TableColumnAlignEnum.center,
    grow: 1,
  },
];
/**
 * @description
 * Header child array for sensor table
 */
export const SENSORS_CHILD_HEADERS: TableColumnInterface[] = [
  {
    field: 'name',
    type: TableColumnEnum.text,
    header: 'app.setting.sensor.fields.varName.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'measurement_unit',
    type: TableColumnEnum.text,
    header: 'app.setting.sensor.fields.measure.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'short_name',
    type: TableColumnEnum.text,
    header: 'app.setting.sensor.fields.shortName.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'icon_class',
    type: TableColumnEnum.icon,
    header: 'app.setting.sensor.fields.icon.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'var_start',
    type: TableColumnEnum.text,
    header: 'app.setting.sensor.fields.start.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'var_length',
    type: TableColumnEnum.text,
    header: 'app.setting.sensor.fields.length.label',
    align: TableColumnAlignEnum.center,
  },
];
